import IUserRegistrationEntity from '@interfaces/IUserRegistrationEntity'
import axios from 'axios'

export const store = (token: string, entities: IUserRegistrationEntity[]): Promise<any> => {
  return axios.post('users/mass-registration', {
    token,
    entities,
  })
}
